// 位置資訊區塊（介壽校區 & 巨輪校區，使用 Tab 切換 + 開放時間 + 地圖）
import React from "react"
import styled from "styled-components"
import { MapPin, Phone, Mail, Clock } from "lucide-react"

const Section = styled.section`
  width: 100%;
  padding: 3rem 0;
  background-color: #f8fafc;
`

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`

const Title = styled.h2`
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e40af;
  text-align: center;
  margin-bottom: 2rem;
`

const Tabs = styled.div`
  display: flex;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
`

const TabButton = styled.button`
  flex: 1;
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ active }) => (active ? '#1d4ed8' : '#374151')};
  background-color: ${({ active }) => (active ? '#ffffff' : '#f1f5f9')};
  border: none;
  border-bottom: ${({ active }) => (active ? '3px solid #1d4ed8' : '3px solid transparent')};
  cursor: pointer;
  transition: all 0.2s ease;
`

const Grid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const Card = styled.div`
  background-color: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
`

const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 1rem;
`

const InfoBlock = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
`

const IconWrapper = styled.div`
  margin-right: 0.75rem;
  margin-top: 0.25rem;
  color: #1d4ed8;
`

const InfoContent = styled.div`
  font-size: 0.875rem;
  color: #374151;
  line-height: 1.5;
`

const IframeBox = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: #e5e7eb;
`

const campusData = [
  {
    id: "campus-1",
    title: "空軍航空技術學院 資圖中心（介壽校區）",
    address: "高雄市岡山區介壽西路198號",
    phone: "07-6268782",
    email: "-",
    hours: "週一至週五：08:00 - 17:00\n週六、日及國定假日：休館",
    map: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.4597945862183!2d120.2810337!3d22.785420599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0e9be9033ebf%3A0x70922534516da039!2zODIw6auY6ZuE5biC5bKh5bGx5Y2A5LuL5aO96KW_6LevMTk46Jmf!5e0!3m2!1szh-TW!2stw!4v1743660765210!5m2!1szh-TW!2stw`,
  },
  {
    id: "campus-2",
    title: "空軍航空技術學院 資圖中心（巨輪校區）",
    address: "高雄市岡山區巨輪路1號",
    phone: "07-6267542",
    email: "-",
    hours: "週一至週五：08:00 - 17:00\n週六、日及國定假日：休館",
    map: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.133790433161!2d120.2793486!3d22.797505899999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0c215831d3cb%3A0x1dd4e1e34f592ec2!2zODIw6auY6ZuE5biC5bKh5bGx5Y2A5beo6Lyq6LevMeiZnw!5e0!3m2!1szh-TW!2stw!4v1743660827271!5m2!1szh-TW!2stw`,
  },
]

const LocationSection = () => {
  const [activeTab, setActiveTab] = React.useState("campus-1")
  const current = campusData.find((campus) => campus.id === activeTab)

  return (
    <Section id="location">
      <Container>
        <Title>位置資訊</Title>

        <Tabs>
          {campusData.map((campus) => (
            <TabButton
              key={campus.id}
              active={activeTab === campus.id}
              onClick={() => setActiveTab(campus.id)}
            >
              {campus.id === 'campus-1' ? '介壽校區' : '巨輪校區'}
            </TabButton>
          ))}
        </Tabs>

        {current && (
          <Grid>
            <Card>
              <CardTitle>{current.title}</CardTitle>
              <InfoBlock>
                <IconWrapper><Clock size={18} /></IconWrapper>
                <InfoContent style={{ whiteSpace: 'pre-line' }}>{current.hours}</InfoContent>
              </InfoBlock>
              <InfoBlock>
                <IconWrapper><MapPin size={18} /></IconWrapper>
                <InfoContent>{current.address}</InfoContent>
              </InfoBlock>
              <InfoBlock>
                <IconWrapper><Phone size={18} /></IconWrapper>
                <InfoContent>{current.phone}</InfoContent>
              </InfoBlock>
              <InfoBlock>
                <IconWrapper><Mail size={18} /></IconWrapper>
                <InfoContent>{current.email}</InfoContent>
              </InfoBlock>
            </Card>

            <IframeBox>
              <iframe
                src={current.map}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${current.title} 地圖`}
              ></iframe>
            </IframeBox>
          </Grid>
        )}
      </Container>
    </Section>
  )
}

export default LocationSection
